import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class AuthControllerService {

  constructor(
    private http: MiraieService,
  ) { }

  //権限一覧取得
  getAuthList() {
    var url = "auth/list";

    return this.http.get(url);
  }

  //権限編集
  updateAuthList(list) {
    var url = "auth/update";

    return this.http.post(url, list);
  }

  //権限追加
  addAuthPost(post) {
    var url = "auth/update";

    this.http.post(url, post).subscribe();
  }

  //権限追加
  insertAuthPost(post) {
    var url = "auth/insert";

    return this.http.post(url, post);
  }

  //権限削除
  deleteAuthPost(code) {
    var url = "auth/delete";
    let param = { code };

    return this.http.post(url, param);
  }
}
